
import Vue from "vue";
import {Component} from "vue-property-decorator";
import moment from "moment";
import TopNav from "@/components/TopNav.vue";

@Component({
  components: {TopNav}
})
export default class App extends Vue {
  get year(): string {
    return moment().format('YYYY')
  }
}
